module.exports = __webpack_public_path__ + "static/windlicht-bunt.bdfde3ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thumbs/windlicht-bunt.jpg
// module id = 561
// module chunks = 35783957827783